import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { availableDishesActions } from '../store/slices/menu-slices';

const useGenerateTomorrowData = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const today = new Date();
        today.setDate(today.getDate() + 1); // Add one day to the current date
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const dateForBack = `${today.getFullYear()}-${month}-${day}`;  // Tomorrow's date in YYYY-MM-DD format

        dispatch(availableDishesActions.changeDataOfDay(dateForBack));

    }, [dispatch]);

};

export { useGenerateTomorrowData };
